import React, { Component } from "react";
import {
  Container,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Paper,
  CssBaseline,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  RadioGroup,
  Radio
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import GetAppIcon from "@mui/icons-material/GetApp";
import { toast } from "react-toastify";
import CurrencyInput from "../common/CurrencyInput";
import ScrollToTopBtn from "../common/ScrollToTop";
import * as dataApi from "../../api/dataApi";

class CapitalCall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      capitalCalls: [],
      member: "tff",
      years: [],
      year: "",
      capitalCall: {},
      open: false,
      openEdit: false,
      error: {},
      page: 0,
      rowsPerPage: 10,
      sortDirection: "asc",
    };
  }

  async componentDidMount() {
    const years = await dataApi.getYears(this.state.member);
    const lastYear = new Date().getFullYear() - 1;
    if (years) {
      this.setState({
        year: years.includes(lastYear) ? lastYear : years[0],
        years: years.reverse(),
      });
      this.getCapitalCalls(years[0]);
    }
  }

  getCapitalCalls = async (year) => {
    const capitalCalls = await dataApi.getAllCapitalCallsByOrg(this.state.member, year);
    if (capitalCalls) {
      capitalCalls.sort((a, b) => a.incidentYear - b.incidentYear);
      this.setState({ capitalCalls });
    } else {
      this.setState({ capitalCalls: [] });
    }
  };

  handleOpen = () => this.setState({ capitalCall: {}, error: {}, open: true });
  handleOpenEdit = (capitalCall) => this.setState({ capitalCall, error: {}, openEdit: true });
  handleClose = () => this.setState({ open: false });
  handleCloseEdit = () => this.setState({ openEdit: false });

  handleSave = async () => {
    console.log("Trying to save")

    if (!this.formIsValid()) return;
    const { capitalCall, year, member } = this.state;
    if (capitalCall.amount) {
      capitalCall.amount = parseFloat(capitalCall.amount.replace(/[.\s]/g, ""));
    }
    capitalCall.transactionYear = year;

    const response = capitalCall.summoningId
      ? await dataApi.updateCapitalCall(capitalCall)
      : await dataApi.newCapitalCall(member, capitalCall);

    if (response) {
      toast.success(
        capitalCall.summoningId ? "Innkalling er oppdatert" : "Ny innkalling er lagret"
      );
      this.getCapitalCalls(year);
    } else {
      toast.error("Det skjedd noe feil...");
    }
    this.setState({ open: false, openEdit: false });
  };

  handleDelete = async (capitalCall) => {
    const confirmed = window.confirm("Er du sikker på at du vil slette innkallingen?");
    if (!confirmed) return;

    const result = await dataApi.deleteCapitalCall(capitalCall.summoningId);
    if (result) {
      toast.success("Innkallingen er slettet.");
      this.getCapitalCalls(this.state.year);
    } else {
      toast.error("Kunne ikke slette innkallingen.");
    }
  };


  handleExcelDownload = async (capitalCall) => {
    const success = await dataApi.getExcelFile(capitalCall.summoningId, true);
    if (success === false) {
      toast.error("Filen ble ikke funnet.");
    }
  };


  formIsValid = () => {
    const error = {};
    if (!this.state.capitalCall.incidentYear) error.incidentYear = "Velg skadeår";
    if (!this.state.capitalCall.month) error.month = "Velg måned";
    if (!this.state.capitalCall.amount) error.amount = "Fylle inn beløp";

    this.setState({ error });
    return Object.keys(error).length === 0;
  };

  sortBy = (key) => {
    const { capitalCalls, sortDirection } = this.state;
    capitalCalls.sort((a, b) =>
      sortDirection === "asc" ? (a[key] > b[key] ? 1 : -1) : a[key] < b[key] ? 1 : -1
    );
    this.setState({ capitalCalls, sortDirection: sortDirection === "asc" ? "desc" : "asc" });
  };

  render() {
    const { years, year, member, capitalCall, error, page, rowsPerPage, open, openEdit } =
      this.state;
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    return (
      <>
        <Container maxWidth="lg">
          <main style={{ width: "100%", paddingTop: 80, margin: "auto" }}>
            <Paper style={{ width: "100%", padding: 20 }}>
              <CssBaseline />
              <Typography variant="h5" gutterBottom style={{ marginLeft: 15 }}>
                Akontoinnkallinger
              </Typography>

              <Grid container spacing={2} sx={{ alignItems: "center" }}>
                <Grid item lg={4} sx={{ display: "flex", alignItems: "center", marginLeft: 6, marginRight: -12 }}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      name="member"
                      value={member}
                      onChange={(e) => {
                        const newMember = e.target.value;
                        this.setState({ member: newMember }, () => {
                          this.getCapitalCalls(this.state.year);
                        });
                      }}
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <FormControlLabel
                        value="tff"
                        control={<Radio color="primary" />}
                        label="TFF"
                        sx={{ marginRight: 0.5 }}
                      />
                      <FormControlLabel
                        value="yff"
                        control={<Radio color="primary" />}
                        label="YFF"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item lg={4} sx={{ display: "flex", alignItems: "center" }}>
                  <FormControl variant="standard" sx={{ minWidth: 120 }}>
                    <InputLabel>År</InputLabel>
                    <Select
                      value={year}
                      onChange={(e) => {
                        this.setState({ year: e.target.value });
                        this.getCapitalCalls(e.target.value);
                      }}
                    >
                      {years.map((year, index) => (
                        <MenuItem key={index} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item sx={{ marginLeft: "auto" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxIcon />}
                    onClick={this.handleOpen}
                  >
                    Ny Innkalling
                  </Button>
                </Grid>
              </Grid>



              {/* Table Section */}
              <Paper style={{ marginTop: 20 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Edit</TableCell>
                      <TableCell>Skadeår</TableCell>
                      <TableCell>Andelsår</TableCell>
                      <TableCell>Måned</TableCell>
                      <TableCell align="right">Beløp</TableCell>
                      <TableCell>Excel</TableCell>
                      <TableCell>Slett</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.capitalCalls
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((capitalCall, index) => (
                        <TableRow key={index} hover>
                          <TableCell>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => this.handleOpenEdit(capitalCall)}
                            >
                              <EditIcon />
                            </Button>
                          </TableCell>
                          <TableCell>{capitalCall.incidentYear}</TableCell>
                          <TableCell>{capitalCall.marketShareYear}</TableCell>
                          <TableCell>{capitalCall.month}</TableCell>
                          <TableCell align="right">
                            {capitalCall.amount.toLocaleString("no-NO")}
                          </TableCell>
                          <TableCell align="center">
                            <Button
                              color="primary"
                              onClick={() => this.handleExcelDownload(capitalCall)}
                            >
                              <GetAppIcon />
                            </Button>
                          </TableCell>
                          <TableCell align="center">
                            <Button
                              style={{ color: "#B22222" }}
                              onClick={() => this.handleDelete(capitalCall)}
                            >
                              <DeleteForeverIcon />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 50]}
                  component="div"
                  count={this.state.capitalCalls.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(event, newPage) =>
                    this.setState({ page: newPage })
                  }
                  onRowsPerPageChange={(event) =>
                    this.setState({ rowsPerPage: +event.target.value, page: 0 })
                  }
                />
              </Paper>

              {/* Add Dialog */}
              <Dialog fullWidth open={open} onClose={this.handleClose}>
                <DialogTitle>Ny Innkalling</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth style={{ marginBottom: 16 }}>
                    <InputLabel>Skadeår</InputLabel>
                    <Select
                      name="incidentYear"
                      value={this.state.capitalCall.incidentYear || ""}
                      onChange={(e) =>
                        this.setState({
                          capitalCall: { ...this.state.capitalCall, incidentYear: e.target.value },
                        })
                      }
                      error={this.state.error.incidentYear}
                    >
                      {this.state.years &&
                        this.state.years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth style={{ marginBottom: 16 }}>
                    <InputLabel>Andelsår</InputLabel>
                    <Select
                      name="marketShareYear"
                      value={this.state.capitalCall.marketShareYear || ""}
                      onChange={(e) =>
                        this.setState({
                          capitalCall: { ...this.state.capitalCall, marketShareYear: e.target.value },
                        })
                      }
                    >
                      {this.state.years &&
                        this.state.years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth style={{ marginBottom: 16 }}>
                    <InputLabel>Måned</InputLabel>
                    <Select
                      name="month"
                      value={capitalCall.month || ""}
                      onChange={(e) =>
                        this.setState({ capitalCall: { ...capitalCall, month: e.target.value } })
                      }
                    >
                      {months.map((month, index) => (
                        <MenuItem key={index} value={month}>
                          {month}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth style={{ marginBottom: 16 }}>
                    <label style={{ marginBottom: 8, fontSize: 16 }}>Beløp</label>
                    <CurrencyInput
                      name="amount"
                      value={capitalCall.amount || ""}
                      placeholder="NOK 1.000"
                      includeThousandsSeparator
                      onChange={(e) =>
                        this.setState({ capitalCall: { ...capitalCall, amount: e.target.value } })
                      }
                    />
                  </FormControl>
                  <Typography style={{ color: "red" }}>{error.amount}</Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose}>Avbryt</Button>
                  <Button onClick={this.handleSave}>Lagre</Button>
                </DialogActions>
              </Dialog>

              {/* Edit Dialog */}
              <Dialog fullWidth open={openEdit} onClose={this.handleCloseEdit}>
                <DialogTitle>Rediger Innkalling</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth style={{ marginBottom: 16 }}>
                    <InputLabel>Skadeår</InputLabel>
                    <Select
                      name="incidentYear"
                      value={this.state.capitalCall.incidentYear || ""}
                      onChange={(e) =>
                        this.setState({
                          capitalCall: { ...this.state.capitalCall, incidentYear: e.target.value },
                        })
                      }
                      error={this.state.error.incidentYear}
                    >
                      {this.state.years &&
                        this.state.years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth style={{ marginBottom: 16 }}>
                    <InputLabel>Andelsår</InputLabel>
                    <Select
                      name="marketShareYear"
                      value={this.state.capitalCall.marketShareYear || ""}
                      onChange={(e) =>
                        this.setState({
                          capitalCall: { ...this.state.capitalCall, marketShareYear: e.target.value },
                        })
                      }
                    >
                      {this.state.years &&
                        this.state.years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth style={{ marginBottom: 16 }}>
                    <InputLabel>Måned</InputLabel>
                    <Select
                      name="month"
                      value={this.state.capitalCall.month || ""}
                      onChange={(e) =>
                        this.setState({ capitalCall: { ...this.state.capitalCall, month: e.target.value } })
                      }
                    >
                      {months.map((month, index) => (
                        <MenuItem key={index} value={month}>
                          {month}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth style={{ marginBottom: 16 }}>
                    <label style={{ marginBottom: 8, fontSize: 16 }}>Beløp</label>
                    <CurrencyInput
                      name="amount"
                      value={this.state.capitalCall.amount || ""}
                      includeThousandsSeparator
                      onChange={(e) =>
                        this.setState({ capitalCall: { ...this.state.capitalCall, amount: e.target.value } })
                      }
                    />
                  </FormControl>
                  <Typography style={{ color: "red" }}>{this.state.error.amount}</Typography>
                </DialogContent>

                <DialogActions>
                  <Button onClick={this.handleCloseEdit}>Avbryt</Button>
                  <Button onClick={this.handleSave}>Lagre</Button>
                </DialogActions>

              </Dialog>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </>
    );
  }
}

export default CapitalCall;
